<template>
  <v-app v-if="User && UserCan">
  <!-- <v-app v-if="!loading"> -->
    <Header  />

    <v-main style="background-color: #f9f9f9">
      <router-view/>
    </v-main>
    <div>
      <SideBar/>
      <NotificationsSideBar/>
    </div>

    <div>
      <Footer/>
    </div>
  </v-app>

  <v-app v-else>
    <v-container style="min-height: 90vh" class="mt-4 d-flex flex-column align-center justify-center">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
      Please wait
    </v-container>
  </v-app>
</template>

<script>
import SideBar from '@/components/SideBar.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import NotificationsSideBar from './components/NotificationsSideBar.vue'

export default {
  name: 'App',
  components: {SideBar, Header, Footer, NotificationsSideBar},
  created(){
    this.$store.dispatch('getUser')
    this.$store.dispatch('getUserCan')
  },
}
</script>

